const AmiBrokersSection = () => {
  return (
    <section className="about about--style1 bg-color xts-section">
      <div className="container">
        <div className="about__wrapper">
          <div className="row gx-5 gy-4 gy-sm-0 align-items-center">



            {/* Investment Strategy */}
            <div className="col-lg-12 mt-30">
              <div className="about__content">
                <div
                  className="about__content-inner"
                  data-aos="fade-right"
                  data-aos-duration="500"
                >
            
                  <p>
                    AmiBroker is an advanced technical analysis tool that allows you to evaluate the markets with ease. Whether you are looking at plot charts or back-test or optimize your portfolio, it has the tools and data you need. The plugin will be fed by live market feed allowing you access to all market segments
                  </p>
                


                  <h6> Charting</h6>
                  <p>
                    AmiBroker offers one of the best charting capabilities allowing better understanding of the financial markets. It offers object-oriented drawing charting tools that allow end users to create responsive and interactive charts. You can draw charts using trend lines, regression channels, rays, parallel lines, expansion, Fibonacci retracement, Fibonacci time extensions & time zone, Gann square, cycles, circles, text on chart, arc, arrows and more.
                  </p>



                  <h6>Back Testing & Validation</h6>
   
                   <p>
                    You can forecast the future only when you understand the past. This tool allows true portfolio level testing. It lets you to scan, explore and back-test data on live feed ensuing better trading performance AmiBroker features portfolio-level Optimization that supports all back-testing features it offers. Upto 100 optimization parameters, lightning fast speed, API friendly and 3-D OpenGL animated optimization charts are some but not all the features it offers.
                   </p>

                </div>
              </div>
            </div>






          </div>
        </div>
      </div>
    </section>
  );
};

export default AmiBrokersSection;
